import { useState, useContext, useEffect } from "react";
import axios from "axios";
import Alert from "../Alert";
import { alertContext } from "../contexts/AlertProvider";
import PermissionGate from "../layout/PermissionGate";

const NewIntegration = () => {
  const [data, setData] = useState({});
  const [apiKey, setApiKey] = useState("");
  const [error, setError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [_, setAlertConfig] = useContext(alertContext);
  const token = localStorage.getItem("token");

  const fetchSetting = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}settings/get?key=ordable-api-key`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (res.data.code === 1) {
        const value = res?.data?.data?.value ?? "";
        setApiKey(value);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const createIntegration = async () => {
    if (!apiKey?.trim()) {
      setAlertConfig({
        show: true,
        message: "Invalid api key",
        type: "danger",
      });
      return;
    }
    if (!data?.name?.trim()) {
      setError((prev) => ({ ...prev, name: "Please enter name" }));
      return;
    }
    if (!data?.url?.trim()) {
      setError((prev) => ({ ...prev, url: "Please enter URL" }));
      return;
    }

    setError({});
    setIsUpdating(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}ordable/integration/create`,
        { ...data, apiKey: apiKey },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setAlertConfig({
        show: true,
        message: res.data.message,
        type: res.data.code === 1 ? "success" : "danger",
      });
      reset();
    } catch (err) {
      console.error(err);
      setAlertConfig({
        show: true,
        message: "Something went wrong",
        type: "danger",
      });
    } finally {
      setIsUpdating(false);
    }
  };

  const reset = () => {
    setData({});
    setError({});
  };

  useEffect(() => {
    fetchSetting();
  }, []);

  return (
    <form autoComplete="off" id="newOrdableIntegrationForm">
      <Alert />
      {/* Start:Integration */}
      <div className="row g-5 g-lg-10 mb-5">
        {/*begin::Card*/}
        <PermissionGate required={`create_ordable_integration`}>
          <div className="card">
            {/*begin::Card header*/}
            <div className="card-header">
              {/*begin::Card title*/}
              <div className="card-title">New Integration</div>
              {/*begin::Card title*/}
            </div>
            {/*end::Card header*/}
            {/*begin::Card body*/}
            <div className="card-body py-4">
              <div className="row">
                <div className="col-md-4 mb-3 fv-row">
                  <label className="form-label required">Name</label>
                  <input
                    type="text"
                    className="form-control add-driver-field"
                    placeholder="Enter name"
                    value={data?.name ?? ""}
                    disabled={isLoading || isUpdating}
                    onChange={(e) => {
                      setData((prev) => ({ ...prev, name: e.target.value }));
                      setError((prev) => ({ ...prev, name: "" }));
                    }}
                  />
                  <small className="text-danger mt-2">{error?.name}</small>
                </div>
                <div className="col-md-8 mb-3 fv-row">
                  <label className="form-label required">URL</label>
                  <input
                    type="text"
                    className="form-control add-driver-field"
                    placeholder="Enter URL"
                    value={data?.url ?? ""}
                    disabled={isLoading || isUpdating}
                    onChange={(e) => {
                      setData((prev) => ({ ...prev, url: e.target.value }));
                      setError((prev) => ({ ...prev, url: "" }));
                    }}
                  />
                  <small className="text-danger mt-2">{error?.url}</small>
                </div>
              </div>
            </div>
            {/*end::Card body*/}
            <PermissionGate
              required={`create_ordable_integration`}
              fallback={<></>}
            >
              <div className="card-footer d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={createIntegration}
                  disabled={isLoading || isUpdating}
                  style={{ minWidth: "160px" }}
                >
                  {isLoading || isUpdating ? (
                    <>
                      Please wait...
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </>
                  ) : (
                    "Create Integration"
                  )}
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={reset}
                  disabled={isLoading || isUpdating}
                  style={{ minWidth: "160px" }}
                >
                  Reset
                </button>
              </div>
            </PermissionGate>
          </div>
        </PermissionGate>
        {/*end::Card*/}
      </div>
      {/* End:Integration */}
    </form>
  );
};

export default NewIntegration;
